import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  Icon,
  IconName,
  Text,
  UnstyledButton,
  Z_INDEXES,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {useNotificationCenterOpenedStateManager} from '../useNotificationCenterOpenedStateManager';

export const NotificationCenterDrawerHeader: React.FC<{
  iconName: IconName;
}> = ({iconName}) => {
  const {t} = useTranslation();
  const {cancel} = useNotificationCenterOpenedStateManager();

  return (
    <HeaderWrapper data-testid="notificationCenter-header">
      <BackButton
        onClick={cancel}
        aria-label={t('Close the notification center')}
      >
        <Icon asset={iconName} size="S" />
      </BackButton>
      <TextContainer>
        <Title size="px16" weight="w500">
          {t('Your Notifications')}
        </Title>
      </TextContainer>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  padding: 16px;
  position: sticky;
  top: 0;
  background-color: ${COLORS.Grey4};
  z-index: ${Z_INDEXES.FLYOUT_STICKY_HEADER};

  ${tabletAndUp(css`
    background-color: unset;
    margin: 0;
    padding: 0;
    gap: 5px;
  `)}
`;

const BackButton = styled(UnstyledButton)`
  z-index: 1;
`;

const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 9px 0;
`;

const Title = styled(Text)`
  line-height: 20px;
`;
